import {createFileRoute} from '@tanstack/react-router';
import {BillConversionOptionsPage} from 'features/bill-payment/pages/BillConversionOptionsPage';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/conversion-options',
)({
  component: BillConversionOptionsPage,
});
